import React from "react";
import { Outlet } from "react-router-dom";

const UserFrame = (props) => {
  return (
    <div className='frame padding10'>
      <div className='displayBlock'>
        <h3>Benutzereinstellungen</h3>
        <Outlet />
      </div>
    </div>
  );
};

export default UserFrame;
